import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed} from "vue";
import {DrawerScroll} from "./Drawer";
import Material from "./Material.vue";

interface Props {
  noSpace?: boolean;
  openToLeft?: boolean;
  scroll: DrawerScroll;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Drawer',
  props: {
    noSpace: { type: Boolean },
    openToLeft: { type: Boolean },
    scroll: {}
  },
  setup(__props: any) {

const props = __props;

const drawerClass = computed(() => {
  if (props.scroll === 'scrollable') {
    return 'max-h-96 overflow-y-auto';
  }
  if (props.scroll === 'scrollablePadding') {
    return 'max-h-96 overflow-y-auto pr-3 -mr-3';
  }
  return '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Material, {
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
    space: !props.noSpace,
    class: _normalizeClass(["absolute top-full z-[1] min-w-full w-max border border-tile-border", props.openToLeft ? 'right-0' : 'left-0'])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass([{'space-y-4': !props.noSpace}, drawerClass.value])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2 /* CLASS */)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["space", "class"]))
}
}

})